export default [{
    path: '/cash-movements',
    name: 'cash-movements',
    component: () => import ('@/views/pages/cash-movements/cash-movements-list/CashMovementsList.vue'),
    meta: {
        pageTitle: 'Cash movements',
        breadcrumb: [{ text: 'Cash movements', active: true }, ],
        resource: 'movement',
        action: 'read',
    },
},
{
    path: '/cash-movements/view/:id',
    name: 'cash-movements-view',
    component: () => import ('@/views/pages/cash-movements/cash-movements-view/CashMovementsView.vue'),
    meta: {
        pageTitle: 'View cash',
        breadcrumb: [
            { text: 'Cash Movements', to:'/cash-movements' }, 
            { text: 'View', active: true }
        ],
        resource: 'movement',
        action: 'read',
    },
},
{
    path: '/cash-movements/edit/:id',
    name: 'cash-movements-edit',
    component: () => import ('@/views/pages/cash-movements/cash-movements-edit/CashMovementsEdit.vue'),
    meta: {
        pageTitle: 'Edit cash',
        breadcrumb: [
            { text: 'Cash Movements', to:'/cash-movements' }, 
            { text: 'Edit', active: true }
        ],
        resource: 'movement',
        action: 'read',
    },
},
{
    path: '/cash-movements/add',
    name: 'cash-movements-add',
    component: () => import ('@/views/pages/cash-movements/cash-movements-add/CashMovementsAdd.vue'),
    meta: {
        pageTitle: 'Add cash',
        breadcrumb: [
            { text: 'Cash Movements', to:'/cash-movements' },
            { text: 'Add', active: true }
        ],
        resource: 'movement',
        action: 'read',
    }
}
]